import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./Loading.module.scss";

const Loading = ({ size, className }) => {
  return <div className={cx([className, styles.loader, styles[size]])} />;
};

Loading.defaultProps = {
  size: "medium",
  className: null
};

Loading.propTypes = {
  /** Give size of the spinner */
  size: PropTypes.oneOf(["large", "medium", "small"]),
  /** Give className of the spinner */
  className: PropTypes.string
};

export default Loading;
